<template>
    <div>
        <veui-dialog
            ui="medium"
            title="线索订阅"
            :open.sync="showSubClueModal"
            overlay-class="order-management-dialog"
            @cancel="closeModal('showSubClueModal')"
        >
            <veui-form
                ref="subForm"
                class="sub-form"
                :data="formData"
                :validators="validators"
            >
                <div class="sub-tip">订阅成功后，每日新增线索即时向您推荐</div>
                <veui-field
                    name="receive_phone"
                    label="接收号码"
                    searchable
                    class="phone-input"
                    :rules="[
                        {name: 'required', value: true, message: '请选输入手机号'},
                        {
                            name: 'pattern',
                            value: /^1\d{10}$/,
                            message: '不是正确的手机号',
                            triggers: 'blur',
                        },
                    ]"
                >
                    <veui-input
                        v-model="formData.receive_phone"
                        ui="l"
                        placeholder="请输入手机号"
                    >
                    </veui-input>
                </veui-field>
                <veui-field
                    name="received_week"
                    label="接收日期"
                    searchable
                    class="received-week"
                    :rules="[{name: 'required', value: true, message: '请选择接收日期'}]"
                >
                    <veui-checkbox-group
                        v-model="formData.received_week"
                        :items="flavors"
                        @change="changeWeek"
                    >
                    </veui-checkbox-group>
                </veui-field>
                <veui-fieldset
                    label="接收时段"
                    class="salary"
                    :required="true"
                >
                    <veui-field
                        field="receive_time_start"
                        name="receive_time_start"
                        :rules="numRequiredRule"
                    >
                        <veui-time-picker
                            v-model="formData.receive_time_start"
                            mode="hour"
                            overlay-class="receive-time"
                            clearable
                        />
                    </veui-field>
                    <span class="time-space">至</span>
                    <veui-field
                        :rules="numRequiredRule"
                        field="receive_time_end"
                        name="receive_time_end"
                    >
                        <veui-time-picker
                            v-model="formData.receive_time_end"
                            mode="hour"
                            overlay-class="receive-time"
                            clearable
                        />
                    </veui-field>
                </veui-fieldset>
                <veui-field
                    name="send_msg_channel"
                    label="接收方式"
                    class="mode"
                >
                    <div
                        v-for="item, index in modeList"
                        :key="index"
                        :class="['mode-item', +formData.send_msg_channel === +item.value ? 'actived' : '']"
                        @click="changeMode(item)"
                    >
                        <div class="mode-name">
                            {{ item.label }}
                            <div v-if="item.value === '1'" class="recommend">推荐</div>
                        </div>
                        <div class="mode-content">{{ item.content }}</div>
                        <div class="mode-icon"></div>
                    </div>
                </veui-field>
            </veui-form>
            <template #foot>
                <div class="foot-box">
                    <veui-button
                        ui="primary"
                        class="confirm-btn"
                        @click="confirmSub"
                    >
                        {{ isOpenClueSubscribe ? '确认修改并订阅' : '订阅' }}
                    </veui-button>
                    <veui-button
                        class="cancle-btn"
                        @click="cancleSub"
                    >
                        取消订阅
                    </veui-button>
                </div>
            </template>
        </veui-dialog>
        <!-- 取消订阅二次确认弹窗 -->
        <veui-dialog
            title="确认取消吗？"
            :open.sync="showCancleSubscribeModal"
            :closable="false"
            overlay-class="cancle-subscribe-dialog"
        >
            <div class="content">
                取消订阅后无法收到每日新增线索的即时提醒，易错过高价值线索
            </div>
            <template #foot>
                <div class="foot-btns">
                    <veui-button
                        ui="primary"
                        class="confirm-cancle"
                        @click="confirmCancle"
                    >
                        我再想想
                    </veui-button>
                    <veui-button
                        class="cancle"
                        @click="cancleSubscribe"
                    >
                        残忍取消
                    </veui-button>
                </div>
            </template>
        </veui-dialog>
        <!-- 订阅成功弹窗 -->
        <veui-dialog
            title="订阅成功"
            :open.sync="showSubscibeSuccModal"
            overlay-class="subscribe-succ-dialog"
        >
            <div class="content">
                微信扫码，关注【百度律临服务号】接收提醒请勿转发二维码给他人
            </div>
            <img
                class="qr-code"
                :src="lawyerServiceQrCode"
                alt=""
            />
            <template #foot>
                <div class="foot-btns">
                    <veui-button
                        ui="primary"
                        class="confirm-cancle"
                        @click="closeModal('showSubscibeSuccModal')"
                    >
                        我知道了
                    </veui-button>
                </div>
            </template>
        </veui-dialog>
    </div>
</template>
<script>

import {
    Form,
    Field,
    Button,
    Input,
    CheckboxGroup,
    Dialog,
    TimePicker,
    Fieldset
} from 'veui';
import 'veui-theme-dls-icons';
import isBoolean from 'lodash/isBoolean';
import {mapState, mapActions} from 'vuex';

/**
 * @file sub
 * @author sunhemeng
 */
const url = {
    cityNext: '/bp/api/city/cityAll',
    vipcluesubscibe: '/bp/api/clue/subscribe'
};

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-form': Form,
        'veui-field': Field,
        'veui-time-picker': TimePicker,
        'veui-input': Input,
        'veui-checkbox-group': CheckboxGroup,
        'veui-fieldset': Fieldset
    },
    props: {
        clueSubscibeInfo: {
            type: Object,
            default() {
                return {};
            }
        },
        areaOptions: {
            type: Array,
            default() {
                return [];
            }
        },
        fr: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew
        }),
        isOk() {
            if (this.clueSubscibeInfo && this.formData && this.formData.receive_phone
                && (JSON.stringify(this.formData) === JSON.stringify(this.clueSubscibeInfo))) {
                return false;
            }
            return (this.formData.received_week && this.formData.received_week.length
                && this.formData.receive_phone && this.formData.receive_time_end
                && this.formData.receive_time_start && this.formData.send_msg_channel);
        },
        phone() {
            return this.clueSubscibeInfo && this.clueSubscibeInfo.receive_phone || '';
        },
        // 是否开启线索订阅
        isOpenClueSubscribe() {
            return this.userInfoNew.lawyer_info && +this.userInfoNew.lawyer_info.is_clue_subscibe === 1;
        }
    },
    data() {
        return {
            isWorking: false,
            flavors: [
                {value: '0', label: '每天', disabled: false},
                {value: '1', label: '周一', disabled: false},
                {value: '2', label: '周二', disabled: false},
                {value: '3', label: '周三', disabled: false},
                {value: '4', label: '周四', disabled: false},
                {value: '5', label: '周五', disabled: false},
                {value: '6', label: '周六', disabled: false},
                {value: '7', label: '周日', disabled: false}
            ],
            formData: {},
            showSubClueModal: false,
            numRequiredRule: [
                {
                    name: 'required',
                    value: true,
                    triggers: 'blur'
                }
            ],
            validators: [
                {
                    fields: ['receive_time_start', 'receive_time_end'],
                    handler: (start, end) => {
                        if (start == null || end == null) {
                            return true;
                        }
                        let date = new Date();
                        let a = start.split(':');
                        let b = end.split(':');
                        return new Promise(resolve => {
                            let res = {};
                            if (
                                date.setHours(a[0], a[1]) > date.setHours(b[0], b[1])
                                || date.setHours(a[0], a[1]) === date.setHours(b[0], b[1])
                            ) {
                                res.receive_time_end = '开始时间请早于结束时间';
                            }
                            resolve(Object.keys(res).length ? res : true);
                        });
                    },
                    triggers: ['change', 'submit']
                }
            ],
            isInit: true,
            showCancleSubscribeModal: false, // 取消订阅弹窗展示
            showSubscibeSuccModal: false, // 订阅成功弹窗展示
            modeList: [
                {value: '1', label: '微信服务号推送', content: '将在数据产生后实时发送数据'},
                {value: '0', label: '短信推送', content: '数据受服务商网络影响，会延迟送达，请谨慎选择'}
            ],
            lawyerServiceQrCode: ''
        };
    },
    watch: {
        showSubClueModal: {
            handler(val) {
                // 弹窗展示
                if (val && this.isInit) {
                    this.init();
                }
                this.isInit = true;
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions({
            getUserInfoNew: 'lawStore/getUserInfoNew'
        }),
        // 取消订阅
        cancleSub() {
            this.$wywLog.send({
                serverId: 18596,
                action: 'click',
                area: 'noremind_btn'
            });
            this.closeModal('showSubClueModal');
            this.showCancleSubscribeModal = true;
            this.$wywLog.send({
                serverId: 18596,
                action: 'show',
                area: 'remindconfirm'
            });
        },
        confirmSub() {
            this.$wywLog.send({
                serverId: 18596,
                action: 'click',
                area: this.isOpenClueSubscribe ? 'reviseremind_btn' : 'remindopen_btn'
            });
            this.$refs.subForm.validate().then(flag => {
                if (isBoolean(flag) && flag && this.formData.send_msg_channel) {
                    this.postData();
                }
                else {
                    const toast = {
                        content: '请填写完整信息',
                        duration: 3
                    };
                    this.$Message.info(toast);
                }
            });
            this.$log && this.$log.send({
                type: 'clk',
                value: 'confirm-sub'
            });
        },
        postData() {
            if (this.isWorking || !this.isOk) {
                return;
            }
            let received_week = this.formData.received_week.length === 1 && this.formData.received_week[0] === '0'
                ? '1,2,3,4,5,6,7' : this.formData.received_week.join(',');
            this.isWorking = true;
            const data = {
                ...this.formData,
                received_week,
                is_subscibe: 1,
                fr: this.fr
            };
            this.$http.post(url.vipcluesubscibe, {
                ...data
            }).then(res => {
                this.isWorking = false;
                if (+res.code !== 0) {
                    this.$Message.info('订阅失败，请重试');
                    return;
                }
                this.$emit('subClueSucc');
                this.closeModal('showSubClueModal');
                // 更新订阅状态
                this.getUserInfoNew();
                if (this.formData.send_msg_channel === '1') {
                    this.showSubscibeSuccModal = true;
                    this.$wywLog.send({
                        serverId: 18596,
                        action: 'show',
                        area: 'fwhremind'
                    });
                }
                else {
                    this.$Message.success('已成功订阅短信');
                    this.$wywLog.send({
                        serverId: 18596,
                        action: 'show',
                        area: 'dxtoastremind'
                    });
                }
            }).catch(() => {
                this.$Message.info('订阅失败，请重试');
                this.isWorking = false;
            });
        },
        /**
         * 关闭弹窗
         * @params {String} name 弹窗名称
         */
        closeModal(name) {
            this[name] = false;
        },
        // 我再想想
        confirmCancle() {
            this.$wywLog.send({
                serverId: 18596,
                action: 'click',
                area: 'rethink_btn'
            });
            this.isInit = false;
            this.showSubClueModal = true;
            this.closeModal('showCancleSubscribeModal');
        },
        // 改变接收方式
        changeMode(item) {
            this.formData.send_msg_channel = item.value;
        },

        /**
         * 获取二维码接口
         */

        getQrTicket() {
            this.$http.get('/bp/api/wechat/getqrticket', {
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (!res) {
                    return;
                }
                this.lawyerServiceQrCode = res.qr_url || '';
            }).catch(err => this.$normalizeResponseError(err));
        },
        // 取消订阅
        cancleSubscribe() {
            this.$wywLog.send({
                serverId: 18596,
                action: 'click',
                area: 'confirmnoremind_btn'
            });
            if (this.isWorking) {
                return;
            }
            this.isWorking = true;
            this.$http.post(url.vipcluesubscibe, {
                is_subscibe: 0,
                fr: this.fr
            }).then(res => {
                this.isWorking = false;
                if (+res.code !== 0) {
                    this.$Message.info('取消订阅失败，请重试');
                    return;
                }
                this.$Message.info('取消订阅成功');
                this.formData = {
                    received_week: null,
                    send_msg_channel: '1',
                    receive_phone: '',
                    receive_time_end: '',
                    receive_time_start: ''
                };
                this.closeModal('showCancleSubscribeModal');
                // 更新订阅状态
                this.getUserInfoNew();
                this.$emit('subClueSucc');
            }).catch(() => {
                this.$Message.info('取消订阅失败，请重试');
                this.isWorking = false;
            });
        },

        /**
         * 选择星期几
         */

        changeWeek(val) {
            // 选择的每天
            if (val && val[val.length - 1] === '0') {
                this.formData.received_week = ['0'];
                this.flavors.forEach(item => {
                    if (item.value !== '0') {
                        item.disabled = true;
                    }
                });
                return;
            }
            this.flavors.forEach(item => {
                item.disabled = false;
            });
            let list = val.filter(item => item !== '0');
            this.formData.received_week = list;
        },
        init() {
            const {received_week} = this.clueSubscibeInfo || {};
            this.formData = {
                ...this.clueSubscibeInfo,
                received_week: received_week && received_week.length === 7 ? ['0']
                    : received_week,
                send_msg_channel: this.clueSubscibeInfo && +this.clueSubscibeInfo.send_msg_channel === 0 ? '0' : '1'
            };
            this.flavors.forEach(item => {
                if (this.formData.received_week && this.formData.received_week.includes('0')
                    && item.value !== '0') {
                    item.disabled = true;
                }
                else {
                    item.disabled = false;
                }
            });
        }
    },
    mounted() {
        this.getQrTicket();
        this.$http.get(url.cityNext).then(res => {
            if (!res || +res.code !== 0) {
                return;
            }
            const respData = res?.data;
            respData && respData.map(item => {
                if (item.label && item.label.indexOf('市') >= 0) {
                    item.children = Array.from(item.children[0].children);
                }
                return item;
            });
        }).catch(() => {
        });
    }
};
</script>
<style lang="less" scoped>
.sub-tip {
    font-family: PingFang SC;
    font-size: 12px;
    color: #848691;
    text-align: center;
    margin-top: -2px;
    margin-bottom: 30px;
}

.form-space {
    width: 100%;
    height: 20px;
}

.form-space-big {
    width: 100%;
    height: 50px;
}

.sub-form {
    /deep/ .veui-field-label {
        text-align: left;
        margin-right: 18px;
        width: 5.2em;
        display: flex;
        align-items: center;
    }

    /deep/ .veui-focus {
        box-shadow: none;
        border: 1px solid rgba(56, 85, 213, 1);
    }

    /deep/ .veui-input:hover {
        border: 1px solid rgba(56, 85, 213, 1);
    }

    /deep/ .veui-field {
        margin-bottom: 15px;
    }

    /deep/ .veui-select {
        width: 482px;
        min-height: 38px;
    }

    /deep/ .veui-tag-default {
        height: 28px;
        border: 1px solid rgba(233, 236, 243, 1) !important;
        border-radius: 14px;
        background: none;
    }

    /deep/ .veui-select-expanded .veui-input {
        border: 1px solid rgba(56, 85, 213, 1);
    }

    /deep/ .veui-input {
        height: auto !important;
        min-height: 38px;
        min-height: 40px !important;
        border-radius: 8px !important;
    }

    /deep/ .veui-checkbox-group-items {
        margin-left: 0;
    }

    /deep/ .veui-checkbox {
        margin-left: 0;
        margin-right: 18px;
        margin-top: 6px;
    }

    /deep/ .veui-field-label::before {
        content: "";
        margin-right: 0;
    }

    /deep/ .veui-field-label::after {
        content: " *";
        margin-right: 2px;
        color: #cc1800;
    }

    /deep/ .phone-input {
        .veui-field-main {
            width: 100%;

            .veui-input {
                width: 100%;
            }
        }
    }

    /deep/.mode {
        position: relative;

        &.veui-field {
            display: block;
        }

        .veui-field-content {
            flex-direction: column;
            margin-left: 6px;
        }

        .mode-item {
            width: 584px;
            height: 67px;
            background: #f7f9fc;
            border-radius: 10px;
            padding: 0 26px 0 18px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            box-sizing: content-box;
            margin-top: 6px;
            border: 1px solid transparent;
            cursor: pointer;

            &.actived {
                border-color: #0055ff4d;

                .mode-name {
                    font-weight: 500;
                    color: #05f;
                }

                .mode-icon {
                    background-image: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-clues/Group%2050.png);
                }
            }

            &:not(:first-child) {
                margin-top: 12px;
            }
        }

        .mode-name {
            font-family: PingFang SC;
            font-size: 14px;
            line-height: 22px;
            color: #000;
            display: flex;
            align-items: center;

            .recommend {
                background: linear-gradient(90deg, #ffe99e 6.56%, #ffdc68 94.44%);
                margin-left: 4px;
                width: 36px;
                height: 18px;
                color: #a54300;
                font-family: PingFang SC;
                font-size: 11px;
                font-weight: 500;
                line-height: 18px;
                text-align: center;
                border-radius: 24px;
            }
        }

        .mode-content {
            font-family: PingFang SC;
            font-size: 12px;
            line-height: 12px;
            color: #848691;
            margin-top: 5px;
        }

        .mode-icon {
            position: absolute;
            right: 14px;
            height: 16px;
            width: 16px;
            background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-clues/Rectangle%2054.png) no-repeat center / 100% 100%;
        }
    }
}

.salary {
    /deep/ .veui-field {
        margin-bottom: 0;
    }

    /deep/ &.veui-field {
        height: 40px;

        .veui-field-label {
            height: 40px;
        }
    }

    /deep/ .veui-time-picker {
        width: 250px;
        height: 40px;
    }

    .time-space {
        margin: 0 14px;
    }
}

.foot-box {
    .veui-button {
        width: 100%;
        margin: 0;
        font-family: PingFang SC;
        font-weight: 500;
        text-align: center;
    }

    .confirm-btn {
        height: 40px;
    }

    .cancle-btn {
        border: none;
        background: #fff;
        line-height: 20px;
        font-weight: 400;
        color: #848691;
        margin-top: 24px;
        height: 20px;
    }
}

/deep/.veui-dialog-content-head {
    justify-content: center;
    position: relative;
    padding: 30px 30px 10px 30px;

    .veui-dialog-content-head-title {
        flex-grow: 0;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
        line-height: 22.4px;
        color: #000;
    }

    .veui-dialog-content-head-close {
        position: absolute;
        right: 30px;
    }
}

/deep/.veui-dialog-content-body {
    padding: 0 30px;
}

/deep/.veui-dialog-content-foot {
    padding: 14px 30px 6px;
}

.order-management-dialog {
    /deep/ .veui-dialog-content {
        width: 688px;
    }

    /deep/.veui-dialog-content-body {
        padding-left: 24px !important;
        overflow: hidden;
    }

    /deep/ .received-week {
        .veui-field-messages {
            margin-bottom: -18px;
        }

        &.veui-field {
            height: 40px;
        }

        .veui-checkbox.veui-disabled {
            .veui-checkbox-box-labelled {
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-clues/Group%20427322765.png") no-repeat center / 100% 100%;
            }
        }
    }
}

.cancle-subscribe-dialog,
.subscribe-succ-dialog {
    /deep/.veui-dialog-content {
        width: 310px;
    }

    /deep/.veui-dialog-content-body {
        text-align: center;

        .content {
            font-family: PingFang SC;
            font-size: 12px;
            line-height: 20px;
            text-align: center;
            color: #848691;
        }
    }

    .qr-code {
        height: 114px;
        width: 114px;
        margin: 12px auto 0;
    }

    .foot-btns {
        .veui-button {
            width: 100%;
            margin: 0;
        }

        .confirm-cancle {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 500;
            line-height: 19.6px;
            border-radius: 6px;
            height: 40px;
        }

        .cancle {
            background: #fff;
            color: #848691;
            margin-top: 18px;
            height: 14px;
        }
    }
}
</style>
<style lang="less">
.receive-time {
    .veui-option-group .veui-option {
        align-items: flex-start;
        padding-left: 13px;
    }
}
</style>
